<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">GSA 3080 TSP Evaluation Report</legend>
  </div>
  <div class="grid-row">
    <div class="grid-col-4">
      <label for="reportingYrSelect" class="usa-label">Reporting Year</label>
      <select id="reportingYrSelect" [(ngModel)]="currentYear" class="usa-select"
        (change)="onYearChange($event.target.value)">
        <option hidden value=''>Choose...</option>
        @for (year of years; track year) {
          <option [value]="year.value">
          {{year.name}}</option>
        }
      </select>
    </div>
  </div>
  <!-- <div class="grid-row">
  <button type="button" class="usa-button" (click)="onBtnExport()">Export</button>
</div> -->
<div class="grid-row grid-gap">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
  </div>
</div>
<div class="grid-row margin-top-2">
  <ag-grid-angular
    style="width: 100%; height: 500px;"
    class="ag-theme-alpine"
    [gridOptions]="adminReportsOptions"
    [rowData]="rowData"
    [excelStyles]="excelStyles"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    [columnDefs]="columnDefs"
    [suppressDragLeaveHidesColumns]="true"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>
</div>

